// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Gabarito:wght@400..900&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Space+Grotesk:wght@300..700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-text {
  font-family: "Inter", sans-serif;
  font-size: 0.8rem;
  font-weight: 400;
  color: #424242;
  margin: 0;
}

.text-xs {
  font-family: "Inter", sans-serif;
  font-size: 0.7rem;
  font-weight: 400;
  margin: 0 !important;
}

.text-ss {
  font-family: "Inter", sans-serif;
  font-size: 0.8rem;
  font-weight: 400;
  margin: 0 !important;
}

.text-small {
  font-family: "Inter", sans-serif;
  font-size: 0.8rem;
  font-weight: 400;
  color: #424242;
  margin: 0 !important;
}

.text-sts {
  font-family: "Inter", sans-serif;
  font-size: 1.3rem;
  font-weight: 500;
  margin: 0 !important;
}

.title-small {
  font-family: "Inter", sans-serif;
  font-size: 0.9rem;
  font-weight: 700;
  color: #242323;
  margin: 0;
}

.text-normal{
    font-family: "Inter", sans-serif;
    font-size: 0.84rem;
    font-weight: 400;
    color: #424242;
    margin: 0;
}

.title-normal{
    font-family: "Inter", sans-serif;
    font-size: 1.1rem;
    font-weight: 700;
    color: #242323;
    margin: 0;
}

.title-medium {
  font-family: "Gabarito", sans-serif;
  font-size: 1.3rem;
  font-weight: 600;
  color: #242323;
  margin: 0;
}

.badge-text {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Gabarito", sans-serif;
  font-size: 14px;
}

.home-title {
  font-family: "Inter", sans-serif;
  font-size: 2.9rem;
  font-weight: 800;
  background: linear-gradient(
    180deg,
    #999999,
    #0f0f0f
  ); /* Defina as cores do gradiente */
  -webkit-background-clip: text; /* Clipa o fundo ao formato do texto */
  -webkit-text-fill-color: transparent;
  margin: 0;
}

.home-subtitle {
  font-family: "Inter", sans-serif;
  font-size: 2.9rem;
  font-weight: 800;
  color: #242323;
  margin: 0;
  text-align: center;
  margin-top: -14px;
}

.special-ht {
  background: linear-gradient(
    90deg,
    #FF6600,
    #3f5efb
  ); /* Defina as cores do gradiente */
  -webkit-background-clip: text; /* Clipa o fundo ao formato do texto */
  -webkit-text-fill-color: transparent; /* Torna o texto transparente para mostrar o fundo */
}

.home-text {
  font-family: "Inter", sans-serif;
  font-size: 0.8rem;
  font-weight: 400;
  color: #424242;
}

.link{
    cursor: pointer;
    text-decoration: underline;
}

.link:hover{
    color: #FF6600;
}

.text-banner {
  font-family: "Gabarito", sans-serif;
  font-size: 1.2rem;
  font-weight: 400;
  color: white;
  margin: 0;
}

.ant-select-selection-item {
  font-family: "Inter", sans-serif;
  font-size: 0.8rem;
  font-weight: 400;
  color: #424242;
}

.ant-tag {
  font-family: "Inter", sans-serif;
  font-size: 0.7rem;
}
.ant-steps-item-title {
  font-family: "Inter", sans-serif;
  font-size: 0.8rem !important;
  font-weight: 400;
  color: #424242;
}

@media screen and (max-width: 768px) {
  .home-title {
    font-size: 2rem;
  }

  .home-subtitle {
    font-size: 1.75rem
  }

    .home-text {
        font-size: 0.7rem;
    }

    .title-small {
        font-size: 0.8rem;
    }

    .text-small {
        font-size: 0.7rem;
    }

    .title-normal {
        font-size: 1rem;
    }

    .text-normal {
        font-size: 0.8rem;
    }

    .badge-text {
        font-size: 12px;
    }

    .link {
        font-size: 0.8rem;
    }

    
}`, "",{"version":3,"sources":["webpack://./src/Components/style/text.css"],"names":[],"mappings":"AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB;;;;GAIC,EAAE,iCAAiC;EACpC,6BAA6B,EAAE,sCAAsC;EACrE,oCAAoC;EACpC,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;;;;GAIC,EAAE,iCAAiC;EACpC,6BAA6B,EAAE,sCAAsC;EACrE,oCAAoC,EAAE,oDAAoD;AAC5F;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE;EACF;;IAEE;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;;AAGJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Gabarito:wght@400..900&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Space+Grotesk:wght@300..700&display=swap\");\n\n.menu-text {\n  font-family: \"Inter\", sans-serif;\n  font-size: 0.8rem;\n  font-weight: 400;\n  color: #424242;\n  margin: 0;\n}\n\n.text-xs {\n  font-family: \"Inter\", sans-serif;\n  font-size: 0.7rem;\n  font-weight: 400;\n  margin: 0 !important;\n}\n\n.text-ss {\n  font-family: \"Inter\", sans-serif;\n  font-size: 0.8rem;\n  font-weight: 400;\n  margin: 0 !important;\n}\n\n.text-small {\n  font-family: \"Inter\", sans-serif;\n  font-size: 0.8rem;\n  font-weight: 400;\n  color: #424242;\n  margin: 0 !important;\n}\n\n.text-sts {\n  font-family: \"Inter\", sans-serif;\n  font-size: 1.3rem;\n  font-weight: 500;\n  margin: 0 !important;\n}\n\n.title-small {\n  font-family: \"Inter\", sans-serif;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #242323;\n  margin: 0;\n}\n\n.text-normal{\n    font-family: \"Inter\", sans-serif;\n    font-size: 0.84rem;\n    font-weight: 400;\n    color: #424242;\n    margin: 0;\n}\n\n.title-normal{\n    font-family: \"Inter\", sans-serif;\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: #242323;\n    margin: 0;\n}\n\n.title-medium {\n  font-family: \"Gabarito\", sans-serif;\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #242323;\n  margin: 0;\n}\n\n.badge-text {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \"Gabarito\", sans-serif;\n  font-size: 14px;\n}\n\n.home-title {\n  font-family: \"Inter\", sans-serif;\n  font-size: 2.9rem;\n  font-weight: 800;\n  background: linear-gradient(\n    180deg,\n    #999999,\n    #0f0f0f\n  ); /* Defina as cores do gradiente */\n  -webkit-background-clip: text; /* Clipa o fundo ao formato do texto */\n  -webkit-text-fill-color: transparent;\n  margin: 0;\n}\n\n.home-subtitle {\n  font-family: \"Inter\", sans-serif;\n  font-size: 2.9rem;\n  font-weight: 800;\n  color: #242323;\n  margin: 0;\n  text-align: center;\n  margin-top: -14px;\n}\n\n.special-ht {\n  background: linear-gradient(\n    90deg,\n    #FF6600,\n    #3f5efb\n  ); /* Defina as cores do gradiente */\n  -webkit-background-clip: text; /* Clipa o fundo ao formato do texto */\n  -webkit-text-fill-color: transparent; /* Torna o texto transparente para mostrar o fundo */\n}\n\n.home-text {\n  font-family: \"Inter\", sans-serif;\n  font-size: 0.8rem;\n  font-weight: 400;\n  color: #424242;\n}\n\n.link{\n    cursor: pointer;\n    text-decoration: underline;\n}\n\n.link:hover{\n    color: #FF6600;\n}\n\n.text-banner {\n  font-family: \"Gabarito\", sans-serif;\n  font-size: 1.2rem;\n  font-weight: 400;\n  color: white;\n  margin: 0;\n}\n\n.ant-select-selection-item {\n  font-family: \"Inter\", sans-serif;\n  font-size: 0.8rem;\n  font-weight: 400;\n  color: #424242;\n}\n\n.ant-tag {\n  font-family: \"Inter\", sans-serif;\n  font-size: 0.7rem;\n}\n.ant-steps-item-title {\n  font-family: \"Inter\", sans-serif;\n  font-size: 0.8rem !important;\n  font-weight: 400;\n  color: #424242;\n}\n\n@media screen and (max-width: 768px) {\n  .home-title {\n    font-size: 2rem;\n  }\n\n  .home-subtitle {\n    font-size: 1.75rem\n  }\n\n    .home-text {\n        font-size: 0.7rem;\n    }\n\n    .title-small {\n        font-size: 0.8rem;\n    }\n\n    .text-small {\n        font-size: 0.7rem;\n    }\n\n    .title-normal {\n        font-size: 1rem;\n    }\n\n    .text-normal {\n        font-size: 0.8rem;\n    }\n\n    .badge-text {\n        font-size: 12px;\n    }\n\n    .link {\n        font-size: 0.8rem;\n    }\n\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
